var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import SyfLoaderCL from "syf-component-library/ui/atoms/Loader/SyfLoader";
import styled from "styled-components";
var SyfLoaderStyle = styled(SyfLoaderCL)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var SyfLoader = function () { return _jsx(SyfLoaderStyle, { size: 4.5 }); };
export default SyfLoader;
var templateObject_1;
//# sourceMappingURL=SyfLoader.js.map